module.exports = __webpack_public_path__ + "static/media/RoadCrossed.cf460aa7.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/alset-reactgame-test/commonGameAssets/tiles/RoadCrossed.png
// module id = 431
// module chunks = 0